import TumHo from "./music/Tum Ho.mp3";
import TereTe from "./music/Tere Te.mp3"
import DilNu from "./music/Dil Nu.mp3";
import BinTere from "./music/Bin Tere.mp3";
import NoLove from "./music/No Love.mp3";
import Kesariya from "./music/Kesariya.mp3";

const songs=[
    {
        id:1,
        src:TumHo,
        img:"https://i.scdn.co/image/ab67616d0000b27354e544672baa16145d67612b",
        name:"Tum Ho",
        artist:"Mohit Chauhan"
    },
    {
        id:2,
        src:TereTe,
        img:"https://i.scdn.co/image/ab67616d0000b273852d4ace5ba8cf082b045c38",
        name:"Tere Te",
        artist:"A.P. Dhillon"
    },
    {
        id:3,
        src:DilNu,
        img:"https://i.scdn.co/image/ab67616d0000b2738471bff5344bd04f60ac834a",
        name:"Dil Nu",
        artist:"A.P. Dhillon"
    },
    {
        id:4,
        src:BinTere,
        img:"https://i.scdn.co/image/ab67616d0000b2731992dd7b33baf5887ea4a1ec",
        name:"Bin Tere",
        artist:"Shafqat Amanat Ali"
    },
    {
        id:5,
        src:NoLove,
        img:"https://i.scdn.co/image/ab67616d0000b273c15996961322cdebc37976e4",
        name:"No Love",
        artist:"Shubh"
    },
    {
        id:6,
        src:Kesariya,
        img:"https://i.scdn.co/image/ab67616d0000b273c08202c50371e234d20caf62",
        name:"Kesariya",
        artist:"Pritam"
    }
];

export default songs;